import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import KeysByMonthByWorkflowList from './components/month/KeysByMonthByWorkflowList';
import KeysByWeekByWorkflowList from './components/week/KeysByWeekByWorkflowList';

function KeysByWorkflow() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Keys by workflow"
      MonthList={KeysByMonthByWorkflowList}
      WeekList={KeysByWeekByWorkflowList}
    />
  );
}

export default KeysByWorkflow;
